<script>
	import { onMount, onDestroy } from 'svelte';

	import { createGame, createPubMatch } from './services/firebase-service';

	// import screenfull from 'screenfull';

	import bgPhoto, { photos } from './stores/bg-photo.js';

	import cloudinary from './services/cloudinary';

	import g from './stores/game';

	import Layout from './layout.svelte';

	import { TYPES, TIMER_LENGTHS } from './utils/constants';

	export let authID;

	let playerName;
	let gameSettings;
	try {
		playerName = localStorage.getItem('playerName');
		gameSettings = JSON.parse(localStorage.getItem('gameSettings'));
	}
	catch(e) {}
	playerName = playerName || '';
	gameSettings = gameSettings || {};

	const wordsLists = ['original', 'actors', 'animals'];
	let selectedWordsList = 'original';

	let selectedMatchType = TYPES.friends || gameSettings.selectedMatchType;
	let numPlayersRequired = gameSettings.numPlayersRequired || 6;
	let timerLength = [TIMER_LENGTHS.noTimer,TIMER_LENGTHS.default,TIMER_LENGTHS.slow,TIMER_LENGTHS.slower].indexOf(gameSettings.timerLength) >= 0 ? gameSettings.timerLength : TIMER_LENGTHS.default;

	let creatingGame = false;

	// on create game
	function onCreateGame() {
		if (disabled) {
			return;
		}

		if (!playerName || !selectedWordsList) {
			return;
		}

		playerName = playerName.toString().trim();

		if (!playerName) {
			return;
		}

		if ([TYPES.pub, TYPES.friends].indexOf(selectedMatchType) <= -1) {
			return;
		}

		creatingGame = true;
		// screenfull.request();

		localStorage.setItem('gameSettings', JSON.stringify({ selectedMatchType, numPlayersRequired, timerLength }));

		if (selectedMatchType === TYPES.friends) {
			return createGame(authID, playerName, selectedWordsList, timerLength).then(gameID => {
				g.setGameID(gameID).then(() => {
					creatingGame = false;
				});
				// window.location.assign(`./${createdGame.mnemonic}`);
			});
		}
		else if (selectedMatchType === TYPES.pub) {
			return createPubMatch(authID, playerName, selectedWordsList, timerLength, numPlayersRequired).then(gameID => {
				g.setGameID(gameID).then(() => {
					creatingGame = false;
				});
				// window.location.assign(`./${assignedGame.mnemonic}`);
			});
		}
	}

	$: disabled = !playerName.toString().trim().length || creatingGame;
</script>

<Layout className="dynamic">
	<div class="create-game-container" slot="core">
		<form
			class="create-game-form"
			on:submit|preventDefault={onCreateGame}>

			<fieldset class="founder">
				<legend>What's your name?</legend>
				<input
					class="founder-name-input"
					class:ok={!disabled}
					type="text"
					name="founder-name"
					bind:value={playerName}
					title="Type your name"
					placeholder="Type your name"
					required="true"
					maxlength="13"
				/>
			</fieldset>

			<!--
			<fieldset class="bubble-options match-type">
				<label class="bubble-option">
					<input type="radio" name="selectedMatchType" value={TYPES.pub} bind:group={selectedMatchType} />
					<span class="bubble">
						<span class="title">Play Online</span>
						Match with players online
					</span>
				</label>
				<label class="bubble-option">
					<input type="radio" name="selectedMatchType" value={TYPES.friends} bind:group={selectedMatchType} />
					<span class="bubble">
						<span class="title">Play With Friends</span>
						Share a link with your friends
					</span>
				</label>
			</fieldset>
			-->
			<!--
			<fieldset class="wordsLists">
				<legend>Choose a word list</legend>
				{#each wordsLists as wordsList (wordsList)}
					<label class="wordsListLabel">
						<input type="radio" value={wordsList} bind:group={selectedWordsList} />
						<span class="wordsList">{wordsList}</span>
					</label>
				{/each}
			</fieldset>
			-->

			<!--
			{#if selectedMatchType === TYPES.pub}
				<fieldset class="bubble-options num-players">
					<legend>Number of players</legend>
					<label class="bubble-option">
						<input type="radio" id="4" name="numPlayersRequired" value={4} on:change={e => numPlayersRequired = parseFloat(e.currentTarget.value)} checked={numPlayersRequired === 4} />
						<span class="bubble">
							4 players
						</span>
					</label>
					<label class="bubble-option">
						<input type="radio" id="6" name="numPlayersRequired" value={6} on:change={e => numPlayersRequired = parseFloat(e.currentTarget.value)} checked={numPlayersRequired === 6} />
						<span class="bubble">
							6 players
						</span>
					</label>
					<label class="bubble-option">
						<input type="radio" id="8" name="numPlayersRequired" value={8} on:change={e => numPlayersRequired = parseFloat(e.currentTarget.value)} checked={numPlayersRequired === 8} />
						<span class="bubble">
							8 players
						</span>
					</label>
					<label class="bubble-option">
						<input type="radio" id="10" name="numPlayersRequired" value={10} on:change={e => numPlayersRequired = parseFloat(e.currentTarget.value)} checked={numPlayersRequired === 10} />
						<span class="bubble">
							10 players
						</span>
					</label>
					<label class="bubble-option">
						<input type="radio" id="100" name="numPlayersRequired" value={100} on:change={e => numPlayersRequired = parseFloat(e.currentTarget.value)} checked={numPlayersRequired === 100} />
						<span class="bubble">
							100 players
						</span>
					</label>
				</fieldset>
			{/if}
		-->
			{#if selectedMatchType === TYPES.friends}
				<fieldset class="bubble-options timer-length">
					<legend>Timer speed</legend>
					<label class="bubble-option">
						<input type="radio" name="timerLength" value={TIMER_LENGTHS.default} bind:group={timerLength} />
						<span class="bubble">
							Default
						</span>
					</label>
					<label class="bubble-option">
						<input type="radio" name="timerLength" value={TIMER_LENGTHS.slow} bind:group={timerLength} />
						<span class="bubble">
							More Time
						</span>
					</label>
					<label class="bubble-option">
						<input type="radio" name="timerLength" value={TIMER_LENGTHS.slower} bind:group={timerLength} />
						<span class="bubble">
							Too Much Time
						</span>
					</label>
					<label class="bubble-option">
						<input type="radio" name="timerLength" value={TIMER_LENGTHS.noTimer} bind:group={timerLength} />
						<span class="bubble">
							No Timer
						</span>
					</label>
				</fieldset>
			{/if}

			<fieldset class="bubble-options background-photos">
				<legend>Background</legend>
				{#each photos as photo, i (photo.id)}
				<label class="bubble-option">
					<span
						class="bubble"
						style="background-image: url({cloudinary(photo, 150, true).url})"
						on:click={() => bgPhoto.setPhoto(photo)}
					>
					</span>
				</label>
				{/each}
			</fieldset>

			<fieldset class="buttons">
				<button
					type="submit"
					class="create-game-submit"
					title="Create a new game"
					class:colorcycle={creatingGame}
					disabled={disabled}
				>
					{#if selectedMatchType === TYPES.friends}
						Create Game
					{:else}
						Find Game
					{/if}
				</button>
			</fieldset>
		</form>
	</div>
</Layout>


<style lang="less">
	@import "./variables.less";

	/* .logo-area {
		width: 100%; height: 100%;
		top: 2em;
		text-align: center;
		overflow: hidden;
		.logo {
			max-width: 13vmin; max-height: 13vmin;
			object-fit: contain;
		}
	} */

	.create-game-container {
		display: flex;
		width: 100%; height: 100%;
		padding: 5vmin;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background: rgba(255, 255, 255, 0.6);
		border: 3px solid #313131;
		border-radius: 20%;
		font-size: 1.4em;

		@media (@aspect-ratio) {
			padding: 5vmin 2vmin;
			margin: 0 2vmin;
		}

		.create-game-form {
			display: flex;
			width:100%; height: 100%;
			flex-direction: column;
			align-items: center;
			justify-content: space-between;
			font-size: 1.5em;
			user-select: none; -webkit-touch-callout: none; -webkit-user-select: none; -khtml-user-select: none; -moz-user-select: none; -ms-user-select: none;

			fieldset {
				display: block;
				width: 100%;
				margin: 1em 0;
				text-align: center;
			}

			legend {
				width: 100%;
				margin: 0.2em 0;
				font-size: 0.7em;
				font-weight: 700;
				text-align: center;
			}

			.founder {

				legend {
					font-size: 0.8em;
				}

				.founder-name-input {
					width: 9em;
					padding: 0.5em;
					text-align: center;
					font-size: 1.5em;

					&.ok {
						border-color: #18d72e;;
						box-shadow: 0 0 2em rgba(24, 215, 46, 0.5);
					}
				}
			}

			.background-photos {
				width: 70%;
				.bubble-option {
					.bubble {
						width: 4em;
						background-size: cover;
						background-position: center;
						border-color: transparent;
						box-shadow: none;
					}
				}
			}

			.create-game-submit {
				font-size: 1.2em;
			}

			.match-type {
				margin: 2em 0; padding: 0;
			}
		}
	}

</style>